export default __webpack_public_path__ + "be7ca85cf4110eaeaff4483fc4b85dfb.svg";